module.exports = __webpack_public_path__ + "static/media/page_13.8ccf9997.jpg";